module.exports = __webpack_public_path__ + "img/Weapon_289.8b8042c4.png";